import { Box } from "@mui/material";

export default function MovingGradient({ gradientColor1, gradientColor2 }) {
   // Calculate angle from lower left to upper right of 16:9 frame
   // For a 16:9 frame, the diagonal from lower left to upper right
   // has an angle of atan(9/16) ≈ 29.36 degrees from horizontal
   // CSS gradients measure clockwise from top (0deg = top, 90deg = right)
   // Lower left to upper right: start at 225deg, end at 45deg
   // The gradient direction: 180 - atan(9/16) ≈ 150.64 degrees
   const angle = 180 - (Math.atan(9/16) * 180 / Math.PI); // ≈ 150.64 degrees
   
   return (
      <Box
         sx={{
            width: "100%",
            height: "100%",
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: `linear-gradient(${angle}deg, ${gradientColor1 || '#ff0000'} 0%, ${gradientColor2 || '#0000ff'} 100%)`,
            backgroundSize: "200% 200%",
            animation: "moveGradient 5s ease-in-out infinite alternate",
         }}
      />
   );
}
